<script setup lang="ts">
import Sidebar from '../sections/Sidebar.vue';
import TemplatesStage from '../sections/TemplatesStage.vue';

interface SharingStep {
  tab: 'preview' | 'templates';
}

defineProps<{
  activeStep: number;
  steps: SharingStep[];
  selectedTemplate: number;
  templates: Array<{ name: string; bg: string; accent: string; logo: string; image?: string }>;
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
  (e: 'select-template', idx: number): void;
}>();
</script>

<template>
  <div class="share-system-mock-prod dark">
    <Sidebar :activeStep="activeStep" :steps="steps" @update:activeStep="$emit('update:activeStep', $event)" />
    
    <main class="share-content-mock dark">
      <TemplatesStage 
        :selectedTemplate="selectedTemplate" 
        :templates="templates" 
        @select-template="$emit('select-template', $event)" 
      />
    </main>
  </div>
</template>

<style scoped>
.share-system-mock-prod { display: flex; height: 100%; background: #000; }
.share-content-mock { flex-grow: 1; padding: 32px; background: #111; overflow: hidden; display: flex; flex-direction: column; }

@media (max-width: 768px) {
  .share-system-mock-prod { flex-direction: column; }
  .share-content-mock { padding: 0; background: transparent; }
}
</style>
